/* eslint-disable no-return-assign */
import { Container, Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import { useRef } from 'react';
import prevArrow from '../../../assets/images/svg/prev-icon.svg';
import nextArrow from '../../../assets/images/svg/next-icon.svg';
import './simpleSlider.css';

const settings = {
  className: 'gallery',
  dots: false,
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 500,
      settings: { slidesToShow: 1, slidesToScroll: 1, infinite: false }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2, slidesToScroll: 1, infinite: false }
    },
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3, slidesToScroll: 1, infinite: false }
    }
  ]
};

function SimpleSlider(props) {
  const { sliderTitle, sliderDesc, children, className } = props;
  const slider = useRef();

  const next = () => {
    // call slider next function here
    slider.current.slickNext();
  };

  const previous = () => {
    // call slider previous function here
    slider.current.slickPrev();
  };

  return (
    <section className="overflow-hidden">
      <Container className="container_margin_right_zero simple_slider_sec">
        <Row className={className}>
          <Col md={3}>
            <div className="heading_cont">
              <h3 dir="auto" className="slider_title">
                {sliderTitle || ''}
              </h3>
              {sliderDesc}
              <div className="slider_btns mt-5">
                <div
                  className="prev_btn"
                  onClick={previous}
                  aria-hidden="true"
                  role="button"
                >
                  <img src={prevArrow} alt="prevArrow" />
                </div>
                <div
                  className="next_btn"
                  onClick={next}
                  aria-hidden="true"
                  role="button"
                >
                  <img src={nextArrow} alt="nextArrow" />
                </div>
              </div>
            </div>
          </Col>
          <Col md={9}>
            <Slider
              {...settings}
              ref={(reference) => (slider.current = reference)}
            >
              {children}
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SimpleSlider;
